<div *transloco="let t; prefix: 'uiKit'" class="w-100 position-relative">
  <div class="position-relative">
    @if (multiple() && isDropdownOpen() && selectedItems().length > 0) {
      <button
        type="button"
        class="btn btn-sm btn-light d-flex align-items-center gap-2 close-button"
        [ngbTooltip]="t('placeholders.closeList')"
        [placement]="'left'"
        (click)="closeDropdown()"
      >
        <ui-keenicon name="cross" class="fs-5 text-primary"></ui-keenicon>
      </button>
    }

    <div
      [ngClass]="{
        'loading-input': isLoading(),
      }"
      class="position-relative"
    >
      <input
        coreNoLeadingSpace
        coreDebounceInput
        type="text"
        class="form-control form-control-lg"
        [value]="multiple() ? value() : inputValue()"
        [placeholder]="placeholder()"
        [debounceTime]="debounceTime()"
        [ngClass]="{
          'bg-transparent': !global(),
          'form-control-lg form-control-solid': global(),
        }"
        (debounceInput)="onInput($event)"
        (focus)="onFocus()"
      />
    </div>
  </div>

  @if (description()) {
    <div class="form-text text-muted mt-1">
      {{ description() }}
    </div>
  }

  @if (multiple() && showSelectedBadges() && selectedItems().length > 0) {
    <div class="d-flex flex-wrap gap-2 mt-2">
      @for (item of selectedItems(); track item.id) {
        <span
          class="badge bg-primary d-flex align-items-center text-white gap-2 py-2 px-3"
        >
          <span>{{ item.name }}</span>
          <ui-keenicon
            name="cross-circle"
            class="fs-5 cursor-pointer"
            (click)="removeSelectedItem(item, $event)"
          ></ui-keenicon>
        </span>
      }
    </div>
  }

  @if (isDropdownOpen() && isLoading()) {
    <div
      class="dropdown-menu show w-100 mt-1 shadow-sm autocomplete-dropdown d-flex justify-content-center align-items-center"
      style="min-height: 100px"
    >
      <ui-loader [size]="'small'"></ui-loader>
    </div>
  }

  @if (isDropdownOpen() && !isLoading() && items().length > 0) {
    <div class="dropdown-menu show w-100 mt-1 shadow-sm autocomplete-dropdown">
      @for (item of items(); track item.id) {
        <button
          type="button"
          class="dropdown-item d-flex align-items-center py-3 autocomplete-item"
          [ngClass]="{
            'bg-light': isItemSelected(item),
          }"
          [disabled]="item.disabled ?? false"
          [coreCustomTooltip]="item.statusDescription ?? ''"
          (click)="selectItem(item)"
        >
          @if (multiple()) {
            <input
              coreNoLeadingSpace
              type="checkbox"
              class="form-check-input me-3 pointer-events-none"
              [checked]="isItemSelected(item)"
              [disabled]="item.disabled ?? false"
              (click)="$event.stopPropagation()"
            />
          }
          <div class="d-flex flex-column align-items-start flex-grow-1">
            <span
              class="fw-bold"
              [class.text-dark]="!item.disabled"
              [class.text-muted]="item.disabled"
              >{{ item.name }}</span
            >
            @if (item.subtitle) {
              <small class="text-muted">{{ item.subtitle }}</small>
            }
          </div>
          @if (item.disabled && item.statusLabel) {
            <ui-badge
              [text]="item.statusLabel"
              [severity]="item.statusClass ?? 'secondary'"
              [class]="item.statusBadgeClass ?? ''"
            ></ui-badge>
          }
        </button>
      }
    </div>
  }

  @if (isDropdownOpen() && !isLoading() && !items().length) {
    <div class="dropdown-menu show w-100 mt-1 shadow-sm autocomplete-dropdown">
      <div class="d-flex flex-column align-items-center">
        <div class="dropdown-item text-muted text-center">
          @if (noResultsMessage()) {
            {{ noResultsMessage() }}
          } @else {
            {{ t('placeholders.noResults') }}
          }
        </div>
        <div>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  }
</div>
